export const isNumberField = (key, names) => names.includes(key);
